import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_PAPERTRADER_REGISTRY_KEY, META_TYPE, META_VER } from './paperTraderCommandRegisteryType';

/**
 * Registers the /papertrader command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /papertrader open — opens the PaperTraderWidget card.
 */
export function registerPaperTraderCommand() {
    commandEngine.register('/papertrader', {
        hint: 'Open paper trader',
        params: [{ name: 'view', options: [{ label: 'Open', value: 'open' }] }],
        handler: () => {
            cardPainterManager.openCard(CMD_PAPERTRADER_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
        },
    });
}
